import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { environment } from 'src/environments/environment';

import {
    IAprobarFacturacionResponse,
    IAuditoriaAiu,
    IFacturacionPendiente,
    IFacturacionPendienteDetalle,
    IRechazarFacturacionResponse
} from '../interfaces/IFacturacionPendiente';

/**
 * Servicio del dominio "Facturación pendiente" (portal NODO).
 * Espeja el controlador api/FacturacionPendiente. Respuestas envueltas en ResponseModel<T>.
 */
@Injectable({ providedIn: 'root' })
export class FacturacionPendienteService {
    private http = inject(HttpClient);
    private apiUrl = environment.backUrlApi + 'FacturacionPendiente';

    /** Cola de casos pendientes de aprobación. */
    getPendientes(): Observable<ResponseModel<IFacturacionPendiente[]>> {
        return this.http.get<ResponseModel<IFacturacionPendiente[]>>(this.apiUrl);
    }

    /** Cabecera del caso y sus filas de auditoría. */
    getDetalle(id: number): Observable<ResponseModel<IFacturacionPendienteDetalle>> {
        return this.http.get<ResponseModel<IFacturacionPendienteDetalle>>(`${this.apiUrl}/${id}`);
    }

    /** Auditoría global de cambios de AIU (solo lectura), más reciente primero. */
    getAuditoria(): Observable<ResponseModel<IAuditoriaAiu[]>> {
        return this.http.get<ResponseModel<IAuditoriaAiu[]>>(`${this.apiUrl}/auditoria`);
    }

    /**
     * Aprueba y emite la factura. Respuesta sin envolver (no usa ResponseModel).
     * El `usuario` se omite: la API lo toma del token. Los errores (422/409/404) llegan al caller.
     */
    aprobar(id: number): Observable<IAprobarFacturacionResponse> {
        return this.http.post<IAprobarFacturacionResponse>(`${this.apiUrl}/${id}/aprobar`, {});
    }

    /** Rechaza el caso con un motivo obligatorio. */
    rechazar(id: number, motivo: string): Observable<IRechazarFacturacionResponse> {
        return this.http.post<IRechazarFacturacionResponse>(`${this.apiUrl}/${id}/rechazar`, { motivo });
    }
}
